export const APPLICATION_STAGE = 'APPLICATION_STAGE';
export const SET_INFO = 'SET_INFO';
export const SET_SETTING = 'SET_SETTING';
export const SET_BRANDING = 'SET_BRANDING';
export const SET_LANGUAGE = 'SET_LANGUAGE';
export const SET_FRAMES_FEEDBACK = 'SET_FRAMES_FEEDBACK';
export const SET_TRACKS_FEEDBACK = 'SET_TRACKS_FEEDBACK';

export default {
  APPLICATION_STAGE,
  SET_INFO,
  SET_SETTING,
  SET_BRANDING,
  SET_LANGUAGE,
  SET_FRAMES_FEEDBACK,
  SET_TRACKS_FEEDBACK,
};
